import React from "react";
import { Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Link } from "@/components/common/Link";
import { Textarea } from "@/components/ui/textarea";
import { useForm } from "react-hook-form";
export default function GetInTouch() {
  const form = useForm({
    defaultValues: {
      name: "",
      email: "",
      message: ""
    }
  });
  const onSubmit = (data: any) => {
    console.log(data);
  };
  return <section className="bg-background py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {}
          <div className="animate-fade-in-up">
            <h2 className="text-3xl lg:text-4xl font-display font-bold text-foreground tracking-tight mb-4">
              Get in Touch
            </h2>
            <p className="text-muted-foreground text-base leading-relaxed mb-8">
              Ready to migrate from Microsoft Dynamics GP to Business Central? Reach out to discuss your project.
            </p>

            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
                <FormField control={form.control} name="name" render={({
                field
              }) => <FormItem>
                      <FormLabel>Your Name</FormLabel>
                      <FormControl>
                        <Input placeholder="John Doe" {...field} className="h-12 rounded-md border-border focus-visible:border-primary focus-visible:ring-primary/20" />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} />

                <FormField control={form.control} name="email" render={({
                field
              }) => <FormItem>
                      <FormLabel>Email Address</FormLabel>
                      <FormControl>
                        <Input type="email" placeholder="john@example.com" {...field} className="h-12 rounded-md border-border focus-visible:border-primary focus-visible:ring-primary/20" />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} />

                <FormField control={form.control} name="message" render={({
                field
              }) => <FormItem>
                      <FormLabel>Message</FormLabel>
                      <FormControl>
                        <Textarea placeholder="Tell us about your migration needs..." {...field} className="min-h-32 rounded-md border-border focus-visible:border-primary focus-visible:ring-primary/20" />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} />

                <Button type="submit" className="w-full lg:w-auto bg-primary text-white hover:bg-primary-hover active:bg-primary-active h-12 px-8 rounded-md font-semibold shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[120ms] ease-[var(--ease-spring)]">
                  Send Message
                </Button>
              </form>
            </Form>
          </div>

          {}
          <div className="flex flex-col justify-center space-y-8 animate-fade-in-up-delay-100">
            <div className="card p-8 bg-primary-light-background border border-border shadow-soft">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                  <Mail className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">Email Us</h3>
                  <Link to="mailto:info@gp2bcexpress.com" className="text-primary hover:text-primary-hover transition-colors duration-[120ms] font-medium">
                    info@gp2bcexpress.com
                  </Link>
                </div>
              </div>
            </div>

            <div className="card p-8 bg-secondary-light-background border border-border shadow-soft">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-md bg-secondary/10 flex items-center justify-center">
                  <Phone className="w-6 h-6 text-secondary" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">Call Us</h3>
                  <Link to="tel:+16043379989" className="text-secondary hover:text-secondary-hover transition-colors duration-[120ms] font-medium">
                    604-337-9989
                  </Link>
                  <p className="text-sm text-muted-foreground mt-2">Monday to Friday, 9am - 5pm PST</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-muted-light rounded-md border border-border">
              <p className="text-sm text-muted-foreground leading-relaxed">
                <strong className="text-foreground">Serving clients across Canada and the U.S.</strong> with
                fast, reliable ERP migration services. Starting at $7,500 CAD.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}